"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAreaSchema = exports.createAreaSchema = exports.areaShape = exports.updateCitySchema = exports.createCitySchema = exports.cityShape = exports.updateDistrictSchema = exports.createDistrictSchema = exports.districtShape = exports.updateStateSchema = exports.createStateSchema = exports.stateShape = exports.updateCountrySchema = exports.createCountrySchema = exports.countryShape = void 0;
const zod_1 = require("zod");
exports.countryShape = {
    iso2: zod_1.z.string().length(2).toUpperCase(),
    iso3: zod_1.z.string().length(3).toUpperCase(),
    name: zod_1.z.string().min(1).max(150),
    dialCode: zod_1.z.string().max(10).optional(),
};
exports.createCountrySchema = zod_1.z.object(exports.countryShape);
exports.updateCountrySchema = exports.createCountrySchema.partial();
exports.stateShape = {
    countryId: zod_1.z.string().uuid(),
    code: zod_1.z.string().max(10).optional(),
    name: zod_1.z.string().min(1).max(150),
};
exports.createStateSchema = zod_1.z.object(exports.stateShape);
exports.updateStateSchema = zod_1.z.object({
    code: exports.stateShape.code,
    name: exports.stateShape.name.optional(),
});
exports.districtShape = {
    stateId: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(1).max(150),
};
exports.createDistrictSchema = zod_1.z.object(exports.districtShape);
exports.updateDistrictSchema = zod_1.z.object({
    name: exports.districtShape.name.optional(),
});
exports.cityShape = {
    stateId: zod_1.z.string().uuid(),
    districtId: zod_1.z.string().uuid().optional(),
    name: zod_1.z.string().min(1).max(150),
    pinCode: zod_1.z.string().max(20).optional(),
};
exports.createCitySchema = zod_1.z.object(exports.cityShape);
exports.updateCitySchema = zod_1.z.object({
    districtId: exports.cityShape.districtId,
    name: exports.cityShape.name.optional(),
    pinCode: exports.cityShape.pinCode,
});
/** Registration redesign — the "+ Add New Area" inline-creation dialog's own shape. */
exports.areaShape = {
    cityId: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(1).max(150),
    pinCode: zod_1.z.string().max(20).optional(),
    zone: zod_1.z.string().max(100).optional(),
    ward: zod_1.z.string().max(100).optional(),
};
exports.createAreaSchema = zod_1.z.object(exports.areaShape);
exports.updateAreaSchema = zod_1.z.object({
    name: exports.areaShape.name.optional(),
    pinCode: exports.areaShape.pinCode,
    zone: exports.areaShape.zone,
    ward: exports.areaShape.ward,
});
//# sourceMappingURL=geography.schema.js.map